import { FeatureBlockImageAsset } from '@/components/FeatureBlock';
import FeatureGroups, { FeatureGroupsGroup, FeatureGroupsProps } from '@/components/FeatureGroups';
import { ModuleFeatureGroupsFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { parseHtml } from '@/lib/parse-html';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

interface FeatureGroupsModuleProps {
  props: CraftModuleFragment<ModuleFeatureGroupsFragment>;
}

const FeatureGroupsModule: FC<FeatureGroupsModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const groups =
    props.featureGroups
      ?.map((props): FeatureGroupsGroup | null => {
        if (!props) return null;

        if (props.__typename === 'featureGroups_singleFeature_BlockType') {
          const asset = getSingle(props.featureAsset);
          const featureCta = getSingleLink(props.featureCta);

          if (!asset) return null;

          return {
            id: props.id ?? '',
            heading: props.featureHeading ?? '',
            descriptionHtml: props.description ?? '',
            features: [
              {
                id: '1',
                title: props.featureHeading ?? '',
                src: asset?.url ?? '',
                width: asset?.width ?? 0,
                height: asset?.height ?? 0,
              } as FeatureBlockImageAsset,
            ],
            cta: featureCta
              ? {
                text: featureCta.text,
                href: featureCta.url,
              }
              : undefined,
            backgroundColor: props.backgroundColor?.label ?? undefined,
          };
        }

        if (props.__typename === 'featureGroups_multipleFeatures_BlockType') {
          return {
            id: props.id ?? '',
            heading: props.groupHeading ?? '',
            descriptionHtml: props.description ?? undefined,
            features:
              props.features
                ?.map((feature) => {
                  const asset = getSingle(feature?.featureAsset);

                  if (!asset) return null;

                  return {
                    id: feature?.id ?? '',
                    title: feature?.featureName ?? '',
                    src: asset?.url ?? '',
                    width: asset?.width ?? 0,
                    height: asset?.height ?? 0,
                  } as FeatureBlockImageAsset;
                })
                .filter(notEmpty) ?? [],
            backgroundColor: props.backgroundColor?.label ?? undefined,
          };
        }

        return null;
      })
      .filter(notEmpty) ?? [];

  return (
    <FeatureGroups
      heading={props.heading ?? undefined}
      description={props.description ? parseHtml(props.description) : null}
      groups={groups}
      displayMode={props.displayMode as FeatureGroupsProps['displayMode']}
    />
  );
};

export default FeatureGroupsModule;
